'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M16 48l0 416 416 0 0-310.6-4.7-4.7-96-96-4.7-4.7-6.6 0 0 160-224 0 0-160-80 0zM288 320a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z', 'M342.6 41.4L333.3 32 0 32 0 480 448 480 448 146.7 342.6 41.4zm89.4 112l0 310.6-416 0 0-416 80 0 0 160 224 0 0-160 6.6 0 4.7 4.7 96 96 4.7 4.7zM112 48l192 0 0 144-192 0 0-144zM224 272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;